import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AdminPreferencesState {
  sidebarCollapsed: boolean;
  theme: 'dark' | 'light';
  tableDensity: 'compact' | 'normal' | 'comfortable';
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  setTheme: (theme: 'dark' | 'light') => void;
  setTableDensity: (density: 'compact' | 'normal' | 'comfortable') => void;
}

export const useAdminPreferencesStore = create<AdminPreferencesState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      theme: 'dark',
      tableDensity: 'normal',

      toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
      setTheme: (theme) => set({ theme }),
      setTableDensity: (tableDensity) => set({ tableDensity }),
    }),
    {
      name: 'admin-preferences',
    }
  )
);
